<template>
  <section>
    <nav-component :titulo="'Abonos'" texto="Realizar abono" :link="link" />
    <b-breadcrumb align="is-left">
      <b-breadcrumb-item tag="router-link" to="/">Inicio</b-breadcrumb-item>
      <b-breadcrumb-item active>Abonos</b-breadcrumb-item>
    </b-breadcrumb>

    <h3 class="has-text-centered is-size-5 mb-3 has-text-weight-semibold">
      Datos de {{ cuentaApartado && cuentaApartado.tipo === 'cuenta' ? 'cuenta' : 'apartado' }}
    </h3>
    <cartas-totales-filtradas :registros="datosCuentaApartado" />
    <hr>

    <mensaje-inicial :titulo="'No se han registrado abonos'"
      :subtitulo="'Haz click el botón de la esquina para registrar un nuevo abono'" v-if="!cargando && total === 0" />

    <template v-if="total > 0 || cargando">
      <h3 class="has-text-centered is-size-5 mb-3 has-text-weight-semibold">Lista de abonos</h3>

      <div class="table-toolbar">
        <div class="table-toolbar-left">
          <b-select v-model="porPagina" @input="cambiarPorPagina" size="is-small">
            <option :value="10">10 / pág</option>
            <option :value="20">20 / pág</option>
            <option :value="50">50 / pág</option>
          </b-select>
          <span style="font-size:0.78rem;color:var(--color-text-dim)">{{ total }} abonos</span>
        </div>
        <div class="table-toolbar-right">
          <b-button type="is-primary" size="is-small" icon-left="printer" tag="a"
            :href="`#/pdf/abonos/${cuentaApartado && cuentaApartado.id}`" target="_blank" rel="noopener noreferrer">
            Imprimir
          </b-button>
        </div>
      </div>

      <b-table
        class="box"
        :data="abonos"
        :paginated="true"
        :per-page="porPagina"
        :current-page="pagina"
        :total="total"
        :backend-pagination="true"
        :pagination-rounded="true"
        pagination-position="bottom"
        @page-change="onCambioPagina"
      >
        <b-table-column field="fecha"   label="Fecha"     v-slot="props">{{ formatoFecha(props.row.fecha) }}</b-table-column>
        <b-table-column field="monto"   label="Monto $"   sortable v-slot="props">${{ formatoMonto(props.row.monto) }}</b-table-column>
        <b-table-column                 label="Monto Bs"  v-slot="props">{{ props.row.idTasa ? `Bs. ${formatoMonto(props.row.montoBs)}` : '-' }}</b-table-column>
        <b-table-column                 label="Facturado" v-slot="props">{{ props.row.idTasa ? 'Bolívares' : 'Dólares' }}</b-table-column>
        <b-table-column field="metodo"  label="Método"    sortable v-slot="props">{{ props.row.metodo || props.row.simple }}</b-table-column>
        <b-table-column field="origen"  label="Origen"    sortable v-slot="props">{{ props.row.origen || 'N/A' }}</b-table-column>
        <b-table-column label="Acciones" v-slot="props">
          <div class="is-flex" style="gap:4px">
            <b-button v-if="can('abonos.editar')" type="is-warning" size="is-small" icon-left="pen"
              tag="router-link" :to="{ name: 'EditarAbono', params: { id: props.row.id } }" />
            <b-button type="is-info" size="is-small" icon-left="ticket-outline" @click="generarComprobante(props)" />
            <b-button type="is-danger" size="is-small" icon-left="delete" @click="eliminarAbono(props.row)" />
          </div>
        </b-table-column>
      </b-table>
    </template>

    <b-loading :is-full-page="true" v-model="cargando" :can-cancel="false" />
  </section>
</template>

<script>
import MensajeInicial from '../Extras/MensajeInicial'
import NavComponent from '../Extras/NavComponent'
import HttpService from '../../Servicios/HttpService'
import Utiles from '../../Servicios/Utiles'
import CartasTotalesFiltradas from '../Extras/CartasTotalesFiltradas.vue'

export default {
  name: "AbonosComponent",
  components: { MensajeInicial, NavComponent, CartasTotalesFiltradas },

  data: () => ({
    tasa: null,
    cargando: false,
    abonos: [],
    pagina: 1,
    porPagina: 20,
    total: 0,
    cuentaApartado: null,
    datosCuentaApartado: [],
    link: null,
  }),

  async mounted() {
    const resultado = await HttpService.registrar('ventas.php', { accion: 'obtener_tasa' })
    this.tasa = resultado.valor
    await this.obtenerAbonos()
    if (Number(this.cuentaApartado.porPagar) === 0 || !this.can('abonos.registrar')) return
    this.link = { name: 'RealizarAbono', params: { id: this.$route.params.id } }
  },

  methods: {
    formatoMonto(v) { return Utiles.formatoMonto(v) },
    formatoFecha(fecha) {
      if (!fecha) return 'Fecha inválida'
      const [a, m, d] = fecha.split('-')
      return `${d}-${m}-${a}`
    },

    onCambioPagina(p) { this.pagina = p; this.obtenerAbonos() },
    cambiarPorPagina() { this.pagina = 1; this.obtenerAbonos() },

    generarComprobante({ row }) {
      const datos = { abono: row, cuenta: this.cuentaApartado }
      localStorage.setItem('comprobante-abono', JSON.stringify(datos))
      const ruta = this.$router.resolve({ name: 'PDFAbono' })
      window.open(ruta.href, '_blank')
    },

    async eliminarAbono(abono) {
      this.$buefy.dialog.confirm({
        message: '¿Estás seguro de que deseas eliminar este abono?',
        confirmText: 'Eliminar', cancelText: 'Cancelar', type: 'is-danger',
        onConfirm: async () => {
          this.cargando = true
          try {
            const resp = await HttpService.obtenerConConsultas('ventas.php', { accion: 'eliminar_abono', id: abono.id })
            if (resp && resp.success) {
              this.$buefy.toast.open({ message: 'Abono eliminado correctamente', type: 'is-success' })
              this.obtenerAbonos()
            } else {
              this.$buefy.toast.open({ message: resp.message || 'No se pudo eliminar el abono', type: 'is-danger' })
            }
          } catch {
            this.$buefy.toast.open({ message: 'Error al eliminar el abono', type: 'is-danger' })
          } finally {
            this.cargando = false
          }
        }
      })
    },

    async obtenerAbonos() {
      this.cargando = true
      const datos = await HttpService.obtenerConConsultas('ventas.php', {
        accion: 'obtener_abonos',
        id: this.$route.params.id,
        pagina: this.pagina,
        porPagina: this.porPagina,
      })
      const { abonos, cuentaApartado } = datos

      if (Array.isArray(abonos)) {
        this.abonos = abonos
        this.total = datos.total || abonos.length
      } else {
        this.abonos = abonos.data || abonos
        this.total = abonos.total || this.abonos.length
      }

      this.cuentaApartado = cuentaApartado
      this.datosCuentaApartado = [
        { nombre: 'Cliente',        total: cuentaApartado.nombreCliente, icono: 'account',      clase: 'has-text-primary' },
        { nombre: 'Nº Factura',     total: cuentaApartado.id,            icono: 'receipt',       clase: 'has-text-primary' },
        { nombre: 'Total',          total: this.formatoMonto(cuentaApartado.total),  icono: 'cash',        clase: 'has-text-info' },
        { nombre: 'Pagado',         total: this.formatoMonto(cuentaApartado.pagado), icono: 'check-circle',clase: 'has-text-success' },
        { nombre: 'Por pagar $',    total: `$${this.formatoMonto(cuentaApartado.porPagar)}`, icono: 'clock', clase: 'has-text-danger' },
        { nombre: 'Por pagar Bs',   total: `Bs.${this.formatoMonto(Math.round(cuentaApartado.porPagar * this.tasa * 100) / 100)}`, icono: 'clock', clase: 'has-text-danger' },
      ]
      this.cargando = false
    }
  }
}
</script>
